class TipoDesconto{
    constructor(){
        this.id = null;
        this.nome = '';
        this.dataVigenciaInicial = '';
        this.dataVigenciaFinal = '';
        this.version = '';
        this.idFluxoInstanciaAtividade = '';
        this.idFichaRespostaPai = '';
        this.idCliente = '';
    }
}

export default TipoDesconto;